export default __webpack_public_path__ + "static/media/rate_two.98857d6e.png";